import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import styles from 'modules/User/Accounts/Accounts.module.scss'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const Logout = ({ asButton }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const handleLogout = () => {
    dispatch({ type: 'USER/DELETE_USER_ACCOUNT' })
  }

  return (
    <a
      className={clsx(styles['accounts__connect-link'], {
        [styles['accounts__connect-link_as-button']]: asButton,
      })}
      onClick={handleLogout}
    >
      {t('user::settings.accounts.logout')}
    </a>
  )
}

Logout.propTypes = {
  asButton: PropTypes.bool,
}

export default Logout
